<div class="navigation-links" [class.inline]="!side">
  @for (navLink of _navLinkSig(); track navLink) {
    <a
      class="lighter-mat-badge"
      acNavigationLink
      [class.hide-lg]="!side && navLink.label === 'ROUTES.HOME'"
      [attr.acNavigationLink]="side ? null : side"
      [attr.acDropdownNavigationLink]="side ? side : null"
      [routerLink]="navLink.route"
      routerLinkActive="active"
      ariaCurrentWhenActive="page"
      #routerLinkActive="routerLinkActive"
      (isActiveChange)="_visitHeader($event, navLink.notification)"
      [matBadge]="_getCount | apply: _countersSig() : routerLinkActive.isActive : _visitedSig() : navLink.notification"
      [matBadgeColor]="side ? 'primary' : 'warn'"
      matBadgeSize="small"
    >
      {{ navLink.label | translate | uppercase }}
    </a>
  }
</div>
